<template>
  <div>

    <!-- Progress: start -->
    <div class="mt-4 mb-12">

      <div class="border-b border-gray-200">
        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
          <button v-if="!disableMore && session" @click="handleClick('setup')"
            class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 1 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-700'">
            <span class="hidden sm:block">Hauptangaben</span>
            <span class="block sm:hidden">Hauptang.</span>
          </button>

          <p v-else class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 1 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 '">
            <span class="hidden sm:block">Hauptangaben</span>
            <span class="block sm:hidden">Hauptang.</span>
          </p>


          <button v-if="!disableMore && session" @click="handleClick('questions')"
            class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 2 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-700'">Fragen</button>


          <p v-else class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 2 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700'">
            Fragen</p>


          <button v-if="!disableMore && session" @click="handleClick('team')"
            class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 3 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-700'">Team</button>


          <p v-else class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 3 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700'">
            Team</p>


          <button v-if="!disableMore && session" @click="handleClick('review')"
            class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 4 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 hover:border-gray-300 hover:text-gray-700'">
            <span class="hidden sm:block">Zusammenfassung</span>
            <span class="block sm:hidden">Zusammenf.</span>
          </button>

          <p v-else class="w-1/3 text-center whitespace-nowrap border-b-2  px-1 py-4 text-sm font-medium"
            :class="activeTabIndex === 4 ? 'border-markencode-blue text-markencode-blue' : 'border-transparent text-gray-700 '">
            <span class="hidden sm:block">Zusammenfassung</span>
            <span class="block sm:hidden">Zusammenf.</span>
          </p>

        </nav>
      </div>

    </div>

    <!-- Progress: end -->
  </div>
</template>

<script>
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    HorizontalDivider,
  },

  props: {
    session: {
      type: Object,
      required: false,
      default: () => { },
    },

    activeIndex: {
      type: Number,
      required: false,
      default: 1,
    },

    disableMore: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      activeTabIndex: this.activeIndex,
    };
  },

  methods: {
    handleClick(tab) {
      console.log('tab', tab);
      this.$emit('clicked', tab);
    },
  },
};
</script>